import React from 'react';
import { Box, theme } from '@fiverr-private/theme';
import { BUYABLE_TYPE, PriceWithFees } from '@fiverr-private/price_upfront_components';
import { useGigPageContext } from '@fiverr-private/gig_page_context';
import { Container } from '@fiverr-private/layout_components';
import { DiscountTooltip } from './DiscountTooltip';

interface CrossedPriceProps {
  fontSize: keyof typeof theme.bodySizes;
  discountPercentage: number;
  priceInUsd: number;
}

export const CrossedPrice: React.FC<CrossedPriceProps> = ({
  fontSize = theme.bodySizes.b_md,
  discountPercentage,
  priceInUsd,
}) => {
  const { currencyConverter } = useGigPageContext();

  return (
    <Container display="inlineFlex" alignItems="center">
      <PriceWithFees
        netPrice={priceInUsd}
        currency={currencyConverter.getCurrency()}
        buyableType={BUYABLE_TYPE.GIG}
        typographyProps={{ fontWeight: 'normal', size: fontSize, decoration: 'lineThrough', as: 'p' }}
        hideDescription
      />
      <Box as="span" marginLeft="2">
        <DiscountTooltip discountPercentage={discountPercentage} />
      </Box>
    </Container>
  );
};
